import React, { PureComponent } from 'react'
import classnames from 'classnames'
import Moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import ImmutableProptypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import Autosuggest from 'react-autosuggest'
import $ from 'jquery'
import Modal from 'react-modal'
import { Link } from 'react-router'
import 'react-rangeslider/lib/index.css'
import { browserHistory } from 'react-router'
import ReactPlayer from 'react-player'

import {
  startTimer,
  decrementCounter,
  resetCounterRedux,
  addNewRoundOnTimer,
  setCounter,
} from '_modules/counter/actions'
import {
  checkCurrentTask,
  startTask,
  completeTask,
  stopTask,
  continueTask,
  updateTaskStatus,
} from '_modules/current-task/actions'
import { updateLastActivityAt } from '_modules/user/actions'
import { updateSettings } from '_modules/settings/actions'
import { createNotification, clearNotifications } from '_modules/notification/actions'
import { createEngagementEntry } from '_modules/engagement/actions'
import { getNotesReceived } from '_modules/collaboration/actions'
import { setVideoProgress } from '_modules/video/actions'
import { isUserLoggedIn } from '_utils/auth'
import { getMindfulBreakDuration } from '_utils/counter'
import { planTypes } from '_utils/planType'
import { USER_STATUS_TYPES } from '_utils/userStatusType'
import { BACKEND_URL } from '_config/environment'
import Icon from '_components/icon'
import FormBody from '_components/formBody'
import FormElement from '_components/formElement'
import Slider from '_components/slider'
import Socket from '_utils/socket'
import { objectToArray, deepCopyJSON } from '_utils/helperFunction'

import Circle from '../circle'

import styles from './styles.css'

momentDurationFormatSetup(Moment)

const mapStateToProps = ({
  counter,
  currentTask,
  user,
  mindfulBreaks,
  notifications,
  settings,
  collab,
  queueCount,
  video,
}) => ({
  counter,
  currentTask,
  user,
  mindfulBreaks,
  notifications,
  settings,
  collab,
  queueCount,
  video,
})

const mapDispatchToProps = {
  startTimer,
  decrementCounter,
  resetCounterRedux,
  addNewRoundOnTimer,
  startTask,
  completeTask,
  stopTask,
  continueTask,
  checkCurrentTask,
  createNotification,
  clearNotifications,
  createEngagementEntry,
  getNotesReceived,
  updateSettings,
  setCounter,
  updateLastActivityAt,
  setVideoProgress,
  updateTaskStatus,
}

class Home extends PureComponent {
  static propTypes = {
    counter: ImmutableProptypes.map,
    user: ImmutableProptypes.map,
    mindfulBreaks: ImmutableProptypes.map,
    currentTask: ImmutableProptypes.map,
    settings: ImmutableProptypes.map,
    notifications: ImmutableProptypes.map,
    collab: ImmutableProptypes.map,
    queueCount: PropTypes.number.isRequired,
    startTimer: PropTypes.func.isRequired,
    decrementCounter: PropTypes.func.isRequired,
    resetCounterRedux: PropTypes.func.isRequired,
    addNewRoundOnTimer: PropTypes.func.isRequired,
    startTask: PropTypes.func.isRequired,
    completeTask: PropTypes.func.isRequired,
    stopTask: PropTypes.func.isRequired,
    continueTask: PropTypes.func.isRequired,
    checkCurrentTask: PropTypes.func.isRequired,
    createNotification: PropTypes.func.isRequired,
    clearNotifications: PropTypes.func.isRequired,
    createEngagementEntry: PropTypes.func.isRequired,
    displayNotification: PropTypes.func.isRequired,
    getNotesReceived: PropTypes.func.isRequired,
    updateSettings: PropTypes.func.isRequired,
    setCounter: PropTypes.func.isRequired,
    updateLastActivityAt: PropTypes.func.isRequired,
    setVideoProgress: PropTypes.func.isRequired,
    video: PropTypes.number.isRequired,
    updateTaskStatus: PropTypes.func.isRequired,
  }

  static defaultProps = {
    counter: new Map(),
    user: new Map(),
    mindfulBreaks: new Map(),
    notifications: new Map(),
    currentTask: new Map(),
    settings: new Map(),
    collab: new Map(),
    queueCount: 0,
    video: 0,
  }

  constructor(props) {
    super(props)

    this.state = {
      inputValue: '',
      autocomplete: [],
      suggestions: [],
      message: '',
      isModalOpen: false,
      engagementLevel: 3,
      reflectionText: '',
      modalTaskId: null,
      planType: 100,
      autoStatus: true,
      percentage: 0,
      duration: '15:00',
      status: 0,
      counterValue: 900,
      flexibleTime: false,
      isInProgress: false,
      embedLink: '',
      modalTaskName: '',
    }

    const settings = props.settings.toJS()
    const counter = props.counter.toJS()
    const counterValue =
      counter.type === 2
        ? getMindfulBreakDuration(this.props.mindfulBreaks, counter.name) * 60
        : settings.flexibleTime
        ? settings.flexibleTimeInterval * 1
        : settings.timeInterval * 60

    if (props.location.state && props.location.state.name) {
      const { name, action, logEntry, flexibleTime } = this.props.location.state
      if (flexibleTime) {
        this.state.inputValue = name
        this.state.action = action
        this.state.logEntry = logEntry
      }
    }
  }

  componentDidMount() {
    Modal.setAppElement('body')

    const settings = this.props.settings.toJS()
    const counter = this.props.counter.toJS()
    const counterValue =
      counter.type === 2
        ? getMindfulBreakDuration(this.props.mindfulBreaks, counter.name) * 60
        : settings.flexibleTime
        ? settings.flexibleTimeInterval * 1
        : settings.timeInterval * 60

    // check location state on load
    if (this.props.location.state && this.props.location.state.name) {
      const { name, action, logEntry, flexibleTime, type } = this.props.location.state
      browserHistory.replace({
        pathname: '/',
        state: undefined,
      })
      if (flexibleTime) {
        this.setState({}, () => this.timeInputRef.focus())
      } else {
        if (action === 'continue') {
          this.props.updateTaskStatus(logEntry)
        }

        const payload = {
          name,
          type: type || 1,
          duration: counterValue,
        }
        this.props.startTask(payload)
        // change status if auto
        if (this.state.autoStatus) {
          Socket.emit('changeUserStatus', USER_STATUS_TYPES.FOCUSED)
        }

        // updateLastActivityAt
        this.props.updateLastActivityAt({
          lastActivityAt: new Date(),
        })
      }
    }

    // called on refresh
    if (!this.props.user.get('emailConfirmed', true)) {
      browserHistory.push('/confirm-email')
    } else if (this.props.user.get('token')) {
      if (this.props.user.get('planType') >= 300) {
        this.props.getNotesReceived()
      }
      this.getState(this.props)
      fetch(`${BACKEND_URL || 'http://localhost:3000'}/api/tasks/recentNames`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.props.user.get('token')}`,
        },
      })
        .then(res => res.json())
        .then(data => this.setAutoCompleteData(data))
        .catch(err => console.error(err))
    }
  }

  componentWillReceiveProps(nextProps) {
    this.getState(nextProps)
    if (this.props.currentTask.get('logEntry') && !nextProps.currentTask.get('logEntry')) {
      this.resetHomeAndClearRedux()
    }
  }

  componentWillUnmount() {
    this.props.clearError()
  }

  getState = props => {
    const counter = props.counter.toJS()
    const user = props.user.toJS()
    const settings = props.settings.toJS()
    const currentTask = props.currentTask.toJS()
    const breakArray = objectToArray(props.mindfulBreaks.toJS())

    const flexibleTime = settings.flexibleTime
    const status = user.status
    let counterValue =
      counter.type === 2
        ? getMindfulBreakDuration(props.mindfulBreaks, counter.name) * 60
        : settings.flexibleTime
        ? settings.flexibleTimeInterval * 1
        : settings.timeInterval * 60

    const isInProgress = counter.status === 'in progress'
    const seconds = isInProgress ? counter.counter : counterValue

    const duration = Moment.duration(seconds, 'seconds').format('mm:ss')
    const percentage = ((counterValue - seconds) * 100) / counterValue

    const planType = user.planType * 1
    const autoStatus = settings.autoStatus

    // if currentTask exists and no counter running
    if (currentTask && currentTask.lastOccurence && counter.intervalId === null) {
      // set counter redux (set frontend timer) need counter value, intervalid, name, type,
      // counter value
      const elapsedTime =
        (Date.now() - new Date(currentTask.lastOccurence.createdAt).getTime()) / 1000
      counterValue = Math.round(currentTask.duration - elapsedTime)
      const intervalId = setInterval(this.timer, 1000)
      this.props.startTimer(intervalId, currentTask.name, counterValue, currentTask.type)
    }

    const inputValue = currentTask.name || this.state.inputValue

    const foundBreak = breakArray.find(b => b.name === counter.name)
    let embedLink
    if (foundBreak) {
      embedLink = foundBreak.embedLink
    }

    this.setState({
      counterValue,
      flexibleTime,
      status,
      percentage,
      duration,
      isInProgress,
      planType,
      autoStatus,
      inputValue,
      embedLink,
    })
  }

  setRef = ele => {
    this.timeInputRef = ele
  }

  onContinueClicked = () => {
    const { counter, mindfulBreaks, currentTask, settings } = this.props
    const { inputValue } = this.state

    const counterValue =
      counter.get('type') === 2
        ? getMindfulBreakDuration(mindfulBreaks, counter.get('name')) * 60
        : settings.get('flexibleTime')
        ? settings.get('flexibleTimeInterval') * 1
        : settings.get('timeInterval') * 60

    this.props.addNewRoundOnTimer(counter.get('intervalId'), counterValue)

    const payload = {
      name: inputValue,
      duration: counterValue,
    }

    this.props.continueTask(currentTask.get('logEntry'), payload)

    // clear previous notifications
    this.props.clearNotifications()

    // create notifications from mindful break reminder toggles
    mindfulBreaks
      .toArray()
      .filter(x => x.reminderActive === true)
      .forEach(x => {
        this.props.createNotification(x.name, x.reminderType)
      })

    // updateLastActivityAt
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  onInputChange = event => {
    const { value } = event.target
    this.setState({
      inputValue: value,
    })
  }

  onKeyPress = event => {
    if (event.key === 'Enter') {
      if (!this.state.isModalOpen) {
        this.onPlayButtonClick()
      } else {
        this.onSavePressed()
      }
    }
  }

  onPlayButtonClick = () => {
    const { inputValue, counterValue, action, logEntry } = this.state
    const { counter, mindfulBreaks, settings, log } = this.props

    this.props.audioRef.load()
    this.props.clearError()

    if (!inputValue) {
      this.props.displayError('Enter a task name')
      return
    }

    // check flexible time input
    if (
      settings.get('flexibleTime') &&
      (settings.get('flexibleTimeInterval') === undefined ||
        settings.get('flexibleTimeInterval') === null ||
        isNaN(settings.get('flexibleTimeInterval')))
    )
      return

    this.setAutoCompleteData([{ name: inputValue }])

    // start task to update backend
    if (counter.get('intervalId') === null) {
      const payload = {
        name: inputValue,
        type: 1,
        duration: counterValue,
      }
      this.props.startTask(payload)
    }

    // clear previous notifications
    this.props.clearNotifications()

    // create notifications from mindful break reminder toggles
    mindfulBreaks
      .toArray()
      .filter(x => x.reminderActive === true)
      .forEach(x => {
        this.props.createNotification(x.name, x.reminderType)
      })

    // change status if auto
    if (this.state.autoStatus) {
      Socket.emit('changeUserStatus', USER_STATUS_TYPES.FOCUSED)
    }

    // updateLastActivityAt
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })

    // data filed from today, if contniue
    if (action === 'continue') {
      this.props.updateTaskStatus(logEntry)
      this.setState({
        inputValue: '',
        action: undefined,
        logEntry: undefined,
        taskDuration: undefined,
      })
    }
  }

  onCheckmarkClicked = () => {
    const { currentTask, settings } = this.props

    this.props.completeTask(currentTask.get('logEntry'))

    if (settings.get('trackEngagement') === true) {
      // show engagementform
      this.setState({
        isModalOpen: true,
        modalTaskId: currentTask.get('logEntry'),
        modalTaskName: currentTask.get('name'),
      })
    } else {
      this.displayNotifications()
    }
    this.animateCircle(this.resetHomeAndClearRedux)

    // if flex time, clear flex time interval
    if (settings.get('flexibleTime') === true) {
      const tempSettings = JSON.parse(JSON.stringify(settings.toJS()))
      delete tempSettings.flexibleTimeInterval
      this.props.updateSettings(tempSettings)
    }

    // change status if auto
    if (this.state.autoStatus) {
      Socket.emit('changeUserStatus', USER_STATUS_TYPES.COLLAB)
    }

    // updateLastActivityAt
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.state.autocomplete
        .filter(name => name.toLowerCase().includes(value.toLowerCase()))
        .slice(0, 3),
    })
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    })
  }

  onSuggestionSelected = (event, { suggestion }) => {
    this.setState({
      inputValue: suggestion,
    })
  }

  onSwitchClicked = () => {
    const { currentTask, settings } = this.props

    this.props.stopTask(currentTask.get('logEntry'))
    this.animateCircle(this.resetHomeAndClearRedux)

    // update & close notification
    this.props.clearNotifications()

    // if flex time, clear flex time interval
    if (settings.get('flexibleTime') === true) {
      const tempSettings = JSON.parse(JSON.stringify(settings.toJS()))
      delete tempSettings.flexibleTimeInterval
      this.props.updateSettings(tempSettings)
    }

    // change status if auto
    if (this.state.autoStatus) {
      Socket.emit('changeUserStatus', USER_STATUS_TYPES.COLLAB)
    }

    // updateLastActivityAt
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  onSlideChange = value => {
    this.setState({
      engagementLevel: value,
    })
  }

  onReflectionChange = e => {
    this.setState({
      reflectionText: e.target.value,
    })
  }

  onSkipPressed = () => {
    this.setState(
      {
        isModalOpen: false,
        reflectionText: '',
        engagementLevel: 3,
        modalTaskId: null,
        modalTaskName: '',
      },
      () => {
        this.displayNotifications()

        // updateLastActivityAt
        this.props.updateLastActivityAt({
          lastActivityAt: new Date(),
        })
      }
    )
  }

  onSavePressed = () => {
    const { currentTask } = this.props
    const { modalTaskId, engagementLevel, reflectionText } = this.state
    const payload = {
      logEntry: modalTaskId,
      engagementLevel,
      reflection: reflectionText,
    }
    this.props.createEngagementEntry(payload)

    this.setState(
      {
        isModalOpen: false,
        reflectionText: '',
        engagementLevel: 1,
        modalTaskId: null,
        modalTaskName: '',
      },
      () => {
        this.displayNotifications()
      }
    )

    this.props.stopTask(currentTask.get('logEntry'), payload)
    this.animateCircle(this.resetHomeAndClearRedux)

    // updateLastActivityAt
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  onUpdateStatusClick = e => {
    const settings = this.props.settings.toJS()
    settings.autoStatus = false
    this.props.updateSettings(settings)
    Socket.emit('changeUserStatus', e.currentTarget.id)
    this.setState({ autoStatus: false })
  }

  onAutoStatusClick = () => {
    const settings = this.props.settings.toJS()
    const counter = this.props.counter.toJS()

    settings.autoStatus = !this.state.autoStatus
    this.props.updateSettings(settings)

    if (settings.autoStatus) {
      const status = counter.status === 'in progress' ? 1 : 3
      Socket.emit('changeUserStatus', status)
    }
    this.setState({ autoStatus: !this.state.autoStatus })
  }

  setAutoCompleteData = dataArray => {
    const { autocomplete } = this.state
    const newArray = dataArray.map(item => item.name)
    const uniqueArray = autocomplete.concat(newArray).filter((v, i, a) => a.indexOf(v) === i)
    this.setState({
      autocomplete: uniqueArray,
    })
  }

  setDynamicInputClass = size => {
    if (size <= 25) {
      return 20
    } else if (size > 25 && size <= 40) {
      return 15
    }
    return 12
  }

  handleVideoReady = () => {
    if (this.props.video > 0) {
      this.reactPlayerRef.seekTo(this.props.video)
    }
  }

  handleVideoProgress = info => {
    this.props.setVideoProgress(info.playedSeconds)
  }

  setInputRef = ref => {
    this.inputRef = ref
  }

  displayNotifications = () => {
    // check for notifications for after interval notifications
    this.props.notifications
      .toArray()
      .map(x => x.toJS())
      .forEach(x => {
        if (x.type === 2) {
          this.props.displayNotification(x)
        }
      })
  }

  animateCircle(cb) {
    const animationEnd = (el => {
      const animations = {
        animation: 'animationend',
        OAnimation: 'oAnimationEnd',
        MozAnimation: 'mozAnimationEnd',
        WebkitAnimation: 'webkitAnimationEnd',
      }

      for (const t in animations) {
        if (el.style[t] !== undefined) {
          return animations[t]
        }
      }
    })(document.createElement('div'))

    $('#circle').one(animationEnd, () => {
      setTimeout(() => {
        cb()
        this.setState({
          animation: 'zoomIn',
        })
      }, 300)
    })

    this.setState({
      animation: 'bounceOut',
    })
  }

  renderInputComponent = inputProps => <input {...inputProps} ref={this.setInputRef} />

  renderSuggestion = (suggestion, { query, isHighlighted }) => (
    <span className={classnames(styles.suggestion)} style={{ color: isHighlighted && 'white' }}>
      {suggestion}
    </span>
  )

  renderSuggestionsContainer = ({ containerProps, children, query }) => (
    <div
      {...containerProps}
      className={classnames(styles['suggestion-container'])}
      style={{ flex: 1 }}
    >
      {children}
    </div>
  )

  resetHomeAndClearRedux = () => {
    const { counter } = this.props
    if (counter.get('intervalId')) {
      clearInterval(counter.get('intervalId'))
    }
    this.props.resetCounterRedux()
    this.setState({ inputValue: '' })
  }

  timer = () => {
    const currentTask = this.props.currentTask.toJS()
    // elapsed time = now - startedAt
    // counter time = duration - elapsedTime
    const elapsedTime =
      (Date.now() - new Date(currentTask.lastOccurence.createdAt).getTime()) / 1000
    const counterValue = Math.round(currentTask.duration - elapsedTime)
    this.props.setCounter(counterValue)
    // this.props.decrementCounter()
  }

  divRef = null
  timeInputRef = null

  render() {
    const { counter, user, queueCount } = this.props
    const {
      inputValue,
      suggestions,
      animation,
      isModalOpen,
      engagementLevel,
      reflectionText,
      planType,
      autoStatus,
      percentage,
      duration,
      isInProgress,
      flexibleTime,
      embedLink,
      modalTaskName,
    } = this.state

    const inputValueSize = inputValue.length
    const dynamicInputFontSize = this.setDynamicInputClass(inputValueSize)
    const status = user.get('status')
    const videoHeight = window.innerHeight / 2.5
    const videoWidth = videoHeight * (16 / 9)

    const buttons = [
      { label: 'Skip', onClick: this.onSkipPressed },
      { label: 'Save', onClick: this.onSavePressed },
    ]
    return (
      <div
        ref={div => (this.divRef = div)}
        className={classnames(styles.main, styles.Grid, styles['Grid--alignCenter'])}
      >
        <div className={classnames(styles['Grid-cell'], styles.inputTaskNameContainer)}>
          {isInProgress ? (
            <div className={classnames(styles.taskNameContainer)}>
              <p style={{ color: 'white', fontSize: 20 }}>{inputValue}</p>
              {ReactPlayer.canPlay(embedLink) && (
                <span style={{ marginLeft: 25 }} className={classnames(styles.smallTimerText)}>
                  {duration}
                </span>
              )}
            </div>
          ) : (
            <Autosuggest
              style={{ wordWrap: 'break-word' }}
              suggestions={suggestions}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
              getSuggestionValue={suggestion => suggestion}
              renderSuggestion={this.renderSuggestion}
              renderSuggestionsContainer={this.renderSuggestionsContainer}
              onSuggestionSelected={this.onSuggestionSelected}
              renderInputComponent={this.renderInputComponent}
              inputProps={{
                type: 'text',
                placeholder: 'Now what?',
                className: classnames(styles.input, [isInProgress && styles.disabled]),
                value: inputValue,
                onChange: this.onInputChange,
                disabled: isInProgress,
                autoComplete: 'off',
                autoCorrect: 'off',
                autoCapitalize: 'off',
                spellCheck: 'false',
                onKeyPress: this.onKeyPress,
                // style: { fontSize: `${dynamicInputFontSize}px` },
                style: { fontSize: '20px' },
                autoFocus: true,
              }}
            />
          )}

          {inputValue && !isUserLoggedIn(user) && (
            <p className={classnames(styles.suggestion, styles.notice)}>Please Log In</p>
          )}
        </div>

        {ReactPlayer.canPlay(embedLink) ? (
          <div className={classnames(styles['Grid-cell'], styles.video)}>
            <ReactPlayer
              ref={player => (this.reactPlayerRef = player)}
              url={embedLink}
              controls
              // playing
              width={videoWidth}
              height={videoHeight}
              onReady={this.handleVideoReady}
              onProgress={this.handleVideoProgress}
            />
          </div>
        ) : (
          <div
            id="circle"
            style={{ opacity: !inputValue && !flexibleTime ? 0.2 : 1 }}
            className={classnames(styles['Grid-cell'], styles.counter)}
          >
            <Circle
              percentage={percentage}
              text={duration}
              inProgress={isInProgress}
              onKeyPress={this.onKeyPress}
              setRef={this.setRef}
            />
          </div>
        )}

        <div className={classnames(styles['Grid-cell'])}>
          {!isInProgress && (
            <div>
              {isUserLoggedIn(user) && (
                <Icon type="start" isButton onClick={this.onPlayButtonClick} />
              )}
            </div>
          )}

          {isInProgress && (
            <div>
              {counter.get('counter') <= 0 && (
                <Icon type="continue" isButton onClick={this.onContinueClicked} />
              )}
              <Icon type="done" isButton onClick={this.onCheckmarkClicked} />
              <Icon type="switch" isButton onClick={this.onSwitchClicked} />
            </div>
          )}
        </div>
        {planType >= planTypes.team && (
          <div className={classnames(styles['Grid-cell'])}>
            <div
              tabIndex={-1}
              role="button"
              onClick={this.onAutoStatusClick}
              className={classnames(styles.statusBlockItem)}
            >
              {autoStatus ? 'Auto' : 'Manual'}
            </div>
            <div className={classnames(styles.statusBlockItem)}>
              <button
                id={3}
                onClick={this.onUpdateStatusClick}
                className={classnames(
                  styles['Grid-cell'],
                  styles['u-sizeFit'],
                  styles.deleteButton,
                  [status === USER_STATUS_TYPES.COLLAB ? styles.selected : styles.notSelected]
                )}
              >
                <i style={{ color: 'lime' }} className={classnames('fa fa-circle')} />
              </button>
              <button
                id={2}
                onClick={this.onUpdateStatusClick}
                className={classnames(
                  styles['Grid-cell'],
                  styles['u-sizeFit'],
                  styles.deleteButton,
                  [status === USER_STATUS_TYPES.OPEN ? styles.selected : styles.notSelected]
                )}
              >
                <i style={{ color: 'yellow' }} className={classnames('fa fa-circle')} />
              </button>
              <button
                id={1}
                onClick={this.onUpdateStatusClick}
                className={classnames(
                  styles['Grid-cell'],
                  styles['u-sizeFit'],
                  styles.deleteButton,
                  [status === USER_STATUS_TYPES.FOCUSED ? styles.selected : styles.notSelected]
                )}
              >
                <i style={{ color: 'red' }} className={classnames('fa fa-circle')} />
              </button>
            </div>
            <div className={classnames(styles.statusBlockItem)}>
              <Link
                to={{ pathname: '/collaborate', query: { tab: 2 } }}
                className={classnames(styles.collabLink)}
              >
                [{queueCount}]
              </Link>
            </div>
          </div>
        )}
        <Modal
          isOpen={isModalOpen}
          className={classnames(styles.modal)}
          overlayClassName={classnames(styles.overlay)}
          bodyOpenClassName={classnames(styles['disable-body-scroll'])}
        >
          <FormBody buttons={buttons}>
            <FormElement label="Task" elementContainerStyle={{ textAlign: 'left' }}>
              <span style={{ fontSize: 16, color: 'white' }}>{modalTaskName}</span>
            </FormElement>
            <FormElement label="Rank">
              <Slider
                min={1}
                max={5}
                value={engagementLevel}
                onChange={engagementLevel => this.setState({ engagementLevel })}
                color="#F0A366"
              />
            </FormElement>
            <FormElement label="Reflection" labelStyle={{ alignSelf: 'flex-start' }}>
              <textarea
                id="reflection"
                rows="6"
                value={reflectionText}
                className={classnames(styles['form-textarea'])}
                onChange={this.onReflectionChange}
              />
            </FormElement>
          </FormBody>
        </Modal>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)



// WEBPACK FOOTER //
// ./src/views/home/index.js